import React from 'react';

function SortingFilesContent() {
  return (
    <>
      <p>RepoPrompt offers flexible sorting options for both the main file tree and your selected files.</p>
      
      <h3>Sorting the File Tree</h3>
      <ol>
        <li>Locate the "Sort" button in the toolbar above the file tree panel</li>
        <li>Click the "Sort" button to open a dropdown menu</li>
        <li>Choose your desired sorting criteria:
          <ul>
            <li><strong>Name (A-Z or Z-A):</strong> Alphabetical sorting by file name</li>
            <li><strong>Extension (A-Z or Z-A):</strong> Group files by their type/extension</li>
            <li><strong>Date (Newest or Oldest):</strong> Sort by modification date</li>
          </ul>
        </li>
      </ol>
      
      <h3>Sorting Selected Files</h3>
      <ol>
        <li>In the "Selected Files" panel on the right, locate the "Sort" button</li>
        <li>Click this "Sort" button to choose how the selected file cards are ordered:
          <ul>
            <li><strong>Name (A-Z or Z-A):</strong> Alphabetical sorting by file name</li>
            <li><strong>Tokens (Low-High or High-Low):</strong> Sort by token usage</li>
          </ul>
        </li>
      </ol>
      
      <h3>Changing Selected Files View</h3>
      <p>Next to the "Sort" button in the Selected Files panel, there are view toggle buttons:</p>
      <ul>
        <li><strong>Folder icon:</strong> Group selected files by their parent folders</li>
        <li><strong>File list icon:</strong> Show all selected files in a flat list</li>
      </ul>
      
      <div className="tip-box">
        <strong>Tip:</strong> Sorting by tokens is particularly useful for optimizing context size when working with token-limited LLMs.
      </div>
    </>
  );
}

export default SortingFilesContent;